import React from 'react'
import DashboardNav from './Components/DashboardNav'
import Analytics from './Components/Analytics'
import Footer from '../LandingPage/Components/Footer'

function AnalyticsPage() {
    return (
        <div>
            <DashboardNav />
            <Analytics />
            <Footer />
        </div>
    )
}

export default AnalyticsPage